<template>
  <div
    class="dataview-custom-target btn-add"
    @click="onClickAdd"
    v-click-outside="onCancel"
  >
    <div class="dataview-tip" :style="tipStyle" v-if="showAdd">
      <div class="row">
        <label>功能模块</label>
        <c-selector
          :width="260"
          :store="modules"
          v-model="module"
          keyField="value"
          labelField="name"
          @change="onChangeModule"
        ></c-selector>
      </div>
      <div class="row" v-if="module.value === 'event'">
        <label>事件</label>
        <biz-event-selector
          :appid="appId"
          :platId="platform"
          :width="260"
          v-model="currentEvent"
        ></biz-event-selector>
      </div>
      <div class="row" v-else>
        <label>指标</label>
        <c-selector
          :store="wholeTargets"
          :width="260"
          keyField="value"
          labelField="label"
          v-model="wholeTarget"
        ></c-selector>
      </div>
      <div class="row" v-if="module.value === 'event'">
        <label></label>
        <c-selector
          :width="260"
          :store="dataTypes"
          keyField="value"
          labelField="label"
          v-model="dataType"
        ></c-selector>
      </div>
      <div class="row" v-if="showAnonymous">
        <label></label>
        <c-radio :store="anonymousStore" v-model="isAnonymous"></c-radio>
      </div>
      <div class="bottom">
        <c-button
          type="primary"
          :showLoading="showLoading"
          :disable="disableAdd"
          @click="onAdd"
        >
          确定
        </c-button>
        <c-button @click="onCancel">取消</c-button>
      </div>
      <div class="arrow" :style="arrowStyle">
        <div class="down"></div>
        <div class="up"></div>
      </div>
    </div>
    <div class="custom-add" @click="toAdd">
      <i class="icon-add-thin"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actions } from '../../store/constants'
export default {
  name: 'DataviewAddBtn',
  props: {
    index: {
      type: Number
    }
  },
  data () {
    return {
      currentEvent: null,
      showAdd: false,
      isAnonymous: -1,
      module: { value: 'event' },
      modules: [
        { name: '事件', value: 'event' },
        { name: '整体', value: 'whole' }
      ],
      wholeTarget: { value: 'add' },
      anonymousStore: [
        { label: '全部用户', value: -1 },
        { label: '实名', value: 0 },
        { label: '匿名', value: 1 }
      ],
      dataType: { value: 'users' },
      showLoading: false
    }
  },
  computed: {
    dataTypes () {
      const types = [
        { label: '人数', value: 'users' },
        { label: '次数', value: 'times' }
      ]
      const event = this.currentEvent
      if (
        this.module.value === 'event' &&
        event &&
        event.event_name === 'revenue' &&
        event.owner === 'zg_abp'
      ) {
        types.push({
          label: '总金额',
          value: 'totalRevenue'
        })
      }
      return types
    },
    tipStyle () {
      let style = {}
      if (this.index === 0) {
        style.left = '10px'
      } else if (this.index === 5) {
        style.right = '10px'
        style.left = 'inherit'
      } else {
        style.left = '-15px'
      }
      if (this.wholeTarget.value === 'pv') style.top = '-165px'
      return style
    },
    arrowStyle () {
      const style = {}
      if (this.index === 0) {
        style.left = '70px'
      } else if (this.index === 5) {
        style.right = '70px'
      } else {
        return {
          left: '50%'
        }
      }
      return style
    },
    ...mapState({
      wholeExtends (state) {
        let revenue = null
        let pv = null
        state.bizSys.eventList.forEach(event => {
          if (event.event_name === 'pv' && event.owner === 'zg_abp') {
            pv = event
          }
        })
        return {
          revenue,
          pv
        }
      }
    }),
    wholeTargets () {
      const targets = [
        { label: '新增用户', value: 'add' },
        { label: '活跃用户', value: 'active' }
      ]
      if (this.wholeExtends.pv) {
        targets.push({
          label: '访问次数',
          value: 'pv'
        })
      }
      return targets
    },
    showAnonymous () {
      return (
        this.module.value === 'whole' &&
        ['add', 'active'].includes(this.wholeTarget.value)
      )
    },
    disableAdd () {
      if (this.module.value === 'event') {
        return !this.currentEvent || !this.dataType
      } else {
        return !this.wholeTarget
      }
    },
    addParam () {
      if (this.disableAdd) return
      let param = {
        appId: this.appId,
        plat: this.platform,
        config: {
          name: '',
          module: this.module.value,
          type: null,
          target:
            this.module === event
              ? this.currentEvent.event_id
              : this.wholeTarget.value,
          isAnonymous:
            this.showAnonymous && this.isAnonymous > -1
              ? this.isAnonymous
              : null
        }
      }
      if (this.module.value === 'whole') {
        param.config.type = 'users'
        if (this.wholeTarget.value === 'pv') {
          param.config.target = this.wholeExtends.pv.event_id
          param.config.type = 'pv'
        }
        param.config.module = 'whole'
        param.config.name = `${
          this.showAnonymous && this.isAnonymous > -1
            ? this.isAnonymous
              ? '匿名'
              : '实名'
            : ''
        }${this.wholeTarget.label}`
      } else {
        param.config.name =
          this.currentEvent.alias_name || this.currentEvent.event_name
        param.config.type = this.dataType.value
        param.config.target = this.currentEvent.event_id
      }
      param.config = JSON.stringify(param.config)
      return param
    }
  },
  methods: {
    onChangeModule () {
      this.isAnonymous = -1
    },
    toAdd () {
      this.showAdd = true
    },
    onClickAdd () {
      this.showAdd = true
      document.querySelector('.overview-custom').style['z-index'] = 100
    },
    onAdd () {
      this.showLoading = true
      window.track('实时概览-添加指标', {
        功能模块: this.module.name,
        指标:
          this.module.value === 'event'
            ? this.currentEvent.event_name
            : this.wholeTarget.value,
        维度: this.dataType.label,
        用户筛选: this.anonymousStore.find(
          item => item.value === this.isAnonymous
        ).label
      })
      this.$store
        .dispatch(actions.dataview.addConfig, this.addParam)
        .then(() => {
          this.showLoading = false
          this.$parent.afterAddCustom()
        })
        .catch(err => {
          console.error('添加配置失败', err)
          this.showLoading = false
          this.$message({
            type: 'error',
            message: '添加配置失败'
          })
        })
    },
    reset () {
      this.module = { value: 'event' }
      this.currentEvent = null
      this.isAnonymous = -1
    },
    onCancel () {
      this.showAdd = false
      this.reset()
      document.querySelector('.overview-custom').style['z-index'] = 99
    }
  }
}
</script>

<style lang="sass">
@import './styles/addTarget'
</style>
